export const DEV = false;
export const DEBUG = true;

export const DOMAIN = DEV ? "meh.com" : "orion.space";
